module.exports = __webpack_public_path__ + "media/images/entry/entry_btn3-cd14609db1c516206f26b01b5cf41dcb.gif";